<!--
  wangeditor 富文本编辑器
	Created by 吴乔 on 2018/11/7.
-->
<template>
    <div ref="editorElem" style="text-align:left" id="flexCloum"></div>
</template>

<script type="es6">
  import E from 'wangeditorbfe';

  export default {
    props:['catchData'],
    model: {
      prop: 'catchData',
      event: 'catch'
    },
    data() {
        return{
          editor:null,
          editOkCont:''
        }
    },
    watch:{
      catchData:function (value) {
        this.editor.txt.html(value)
        this.editOkCont = value
      }
    },
    methods: {
      editOk(){
        this.catchDataFn(this.editOkCont);
      },
      insertHTML(value) {     ///  父级插入文本
        this.editor.cmd.do('insertHTML', value)
      },
      clear() {
        this.editor.txt.clear() //清空富文本内容
      },
      catchDataFn(value){
        this.$emit('catch',value)
      }
    },
    mounted() {
      var editor = new E(this.$refs.editorElem);        //创建富文本实例
      editor.customConfig.zIndex = 90;
      this.editor = editor;
      editor.customConfig.pasteFilterStyle = true;// 关闭粘贴样式的过滤
      editor.customConfig.pasteIgnoreImg = false; // 忽略粘贴内容中的图片
      editor.customConfig.uploadImgServer = process.env.CLOUD_SERVICE+'/File';// 上传图片到服务器
      editor.customConfig.uploadImgHeaders = {
        'X-Requested-With': 'XMLHttpRequest',
        'Authorization': localStorage['accessToken']? ("Bearer " +localStorage['accessToken']):''
      }
      editor.customConfig.onchange = (html) => {   //内容change
        this.editOkCont = html
        this.$emit('fwbMonitor',this.editOkCont)
        // this.catchDataFn(html);//最后再将内容抛出去
      };
      editor.customConfig.menus = ['head','bold','fontSize','fontName','italic',
        'underline','strikeThrough','foreColor','backColor','link','list','justify','quote','table','image','video','code','undo','redo'];
      editor.customConfig.linkCheck = function (text, link) {  //插入连接的校验
        return true // 返回 true 表示校验成功
      };
      editor.customConfig.linkImgCheck = function (src) { //  插入网络图片的校验
        return true // 返回 true 表示校验成功
      };
      editor.customConfig.onfocus = function (a) {    ///   获得焦点
      };
      editor.customConfig.onblur = (html)=> {    ///   失去焦点焦点  html 即编辑器中的内容
        this.editOk()
      };
      // 禁用编辑功能
      // editor.$textElem.attr('contenteditable', false)
      // editor.customConfig.uploadImgServer = '你的上传图片的接口';
      // editor.customConfig.uploadFileName = '你自定义的文件名';
      // editor.customConfig.uploadImgHeaders = {
      //   'Accept': '*!/!*',
      //   'Authorization': 'Bearer ' + 'token'    //头部token
      // }
      //下面是最重要的的方法
      let vm = this
      editor.customConfig.uploadImgHooks = {
        before: function (xhr, editor, files) {
          if(!localStorage['accessToken']){
            vm.$http.login() //调用父级方法登录
          }
          // 图片上传之前触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
          // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
          // return {
          //     prevent: true,
          //     msg: '放弃上传'
          // }
        },
        success: function (xhr, editor, result) {



          // 图片上传并返回结果，图片插入成功之后触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
          // success(resp[0].cdnUrl)
          // insertImg(result.data[0].cdnUrl)
          // this.imgUrl = Object.values(result.data).toString();
        },
        fail: function (xhr, editor, result) {
          // 图片上传并返回结果，但图片插入错误时触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
        },
        error: function (xhr, editor) {
          // 图片上传出错时触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
        },
        timeout: function (xhr, editor) {
          // 图片上传超时时触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
        },
        // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
        // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
        customInsert: function (insertImg, result, editor) {
          // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
          // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
          // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
          // let url = Object.values(result.data);     //result.data就是服务器返回的图片名字和链接
          // JSON.stringify(url);    //在这里转成JSON格式
          // insertImg(url);
          // result 必须是一个 JSON 格式字符串！！！否则报错
          result.forEach(t=>{
            insertImg(t.cdnUrl)
          })
          // insertImg(result.data[0].cdnUrl)
        }
      },
      editor.create();
      editor.txt.html(this.catchData)
    },
  }
</script>

<style scoped>
  .editOk{
    position: absolute;
    left: 200px;
    margin-top: -44px;
  }
  /*#flexCloum{*/
    /*width: 960px;*/
  /*}*/
  >>>.w-e-text-container{
    min-height: 500px !important;
    max-width: 100%!important;
  }
  >>>.w-e-text-container img{
    max-width: 880px;
  }
</style>



// WEBPACK FOOTER //
// src/components/document/common/wangEditor.vue